@switch (field.type) {
  @case (DPFormFieldType.SingleLine) {
    <app-single-line
      class="d-block"
      [field]="field"
      [control]="control"
      [disabled]="fieldDisabled"
    ></app-single-line>
  }
  @case (DPFormFieldType.MultiLine) {
    <app-multi-line
      class="d-block"
      [field]="field"
      [control]="control"
      [disabled]="fieldDisabled"
    ></app-multi-line>
  }
  @case (DPFormFieldType.Dropdown) {
    <app-dropdown
      class="d-block"
      [field]="field"
      [control]="control"
      [disabled]="fieldDisabled"
    ></app-dropdown>
  }
  @case (DPFormFieldType.Checkbox) {
    <app-checkbox
      class="d-block"
      [field]="field"
      [control]="control"
      [disabled]="fieldDisabled"
    ></app-checkbox>
  }
  @case (DPFormFieldType.Radio) {
    <app-radio-group
      class="d-block"
      [field]="field"
      [control]="control"
      [disabled]="fieldDisabled"
    ></app-radio-group>
  }
  @case (DPFormFieldType.Date) {
    <app-date
      class="d-block"
      [field]="field"
      [control]="control"
      [disabled]="fieldDisabled"
    ></app-date>
  }
  @case (DPFormFieldType.Multivalue) {
    <app-multivalue
      class="d-block"
      [field]="field"
      [control]="control"
      [disabled]="fieldDisabled"
      [markAsTouched]="markAsTouched"
      [customColumnTpls]="customColumnTpls"
      (onUpdate)="onUpdate.emit()"
    ></app-multivalue>
  }
  @case (DPFormFieldType.TextBlock) {
    <div
      class="form-group"
      [ngClass]="field.customClass"
      [disabled]="fieldDisabled"
    >
      {{ field.label }}
    </div>
  }
  @case (DPFormFieldType.Address) {
    <app-address
      class="d-block"
      [field]="field"
      [control]="control"
      [disabled]="fieldDisabled"
      [markAsTouched]="markAsTouched"
    ></app-address>
  }
  @case (DPFormFieldType.YesNo) {
    <app-yesno-field
      class="d-block"
      [field]="field"
      [control]="control"
      [disabled]="fieldDisabled"
      [markAsTouched]="markAsTouched"
      [customColumnTpls]="customColumnTpls"
    ></app-yesno-field>
  }
  @case (DPFormFieldType.StartEndDate) {
    <app-start-end-date
      class="d-block"
      [field]="field"
      [control]="control"
      [disabled]="fieldDisabled"
      [markAsTouchedSubject]="markAsTouched"
    ></app-start-end-date>
  }
}
<app-field-error
  class="d-block"
  [control]="control"
  [field]="field"
></app-field-error>
